import React, { Component } from "react";
import { Box, Paragraph, Main } from "grommet";

class FourOhFourPage extends Component {
  render() {
    return (
      <Main flex>
        <Box flex align="center" justify="center">
          <Paragraph textAlign="center">
            Page not found. Use the menu above to navigate.
          </Paragraph>
        </Box>
      </Main>
    );
  }
}

export default FourOhFourPage;
